<script lang="ts">
	import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher<{completed:void}>()

  function handleComplete():void {
    dispatch('completed')
  }

</script>

<div>
  <button class="btn-darkBack" on:click={handleComplete}>Complete</button>
  <button class="btn-darkBack" disabled>TestSutton</button>
</div>
